import type { TranslationCatalog } from "../TranslationManager";

export const fr: TranslationCatalog = {
  "labels.cardNumber": "Numéro de carte",
  "labels.expirationDate": "Date d'expiration",
  "labels.cvc": "Code de sécurité",
  "placeholders.cardNumber": "1234 1234 1234 1234",
  "placeholders.expirationDate": "MM / AA",
  "placeholders.cvc": "CVV",
  "errors.invalidCardNumber": "Le numéro de votre carte est invalide.",
  "errors.invalidExpiryDate": "La date d'expiration de votre carte est invalide.",
  "errors.invalidCvc": "Le code de sécurité de votre carte est invalide.",
  "errors.incompleteCardNumber": "Le numéro de votre carte est incomplet.",
  "errors.incompleteExpiryDate": "La date d'expiration de votre carte est incomplète.",
  "errors.incompleteCvc": "Le code de sécurité de votre carte est incomplet.",
  "errors.expiredCard": "Votre carte a expiré.",
  "aria.cardNumber": "Numéro de carte",
  "aria.expirationDate": "Date d'expiration",
  "aria.cvc": "Code de sécurité",
  "aria.cardInput": "Informations de carte",
};
